module.exports = __webpack_public_path__ + "static/img/honour2.c70a35f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/honour2.png
// module id = d/9y
// module chunks = 1